import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mouse-glow"
export default class extends Controller {
  connect() {
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.resetGlow = this.resetGlow.bind(this)

    document.addEventListener("turbo:before-cache", this.resetGlow)

    if (!this.shouldEnable()) {
      this.resetGlow()
      return
    }

    this.element.addEventListener("mousemove", this.handleMouseMove, { passive: true })
    this.element.addEventListener("mouseleave", this.handleMouseLeave)
  }

  disconnect() {
    this.element.removeEventListener("mousemove", this.handleMouseMove)
    this.element.removeEventListener("mouseleave", this.handleMouseLeave)
    document.removeEventListener("turbo:before-cache", this.resetGlow)
    this.resetGlow()
  }

  shouldEnable() {
    return window.matchMedia("(min-width: 768px) and (pointer: fine)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  handleMouseMove(event) {
    const rect = this.element.getBoundingClientRect()

    this.element.style.setProperty("--glow-x", `${event.clientX - rect.left}px`)
    this.element.style.setProperty("--glow-y", `${event.clientY - rect.top}px`)
    this.element.style.setProperty("--glow-opacity", "1")
  }

  handleMouseLeave() {
    this.resetGlow()
  }

  resetGlow() {
    this.element.style.setProperty("--glow-opacity", "0")
    this.element.style.removeProperty("--glow-x")
    this.element.style.removeProperty("--glow-y")
  }
}
